const defaultFormValues = {
    fitting: 'roof',
    type: 'tile',
    size: '',
    compassBearing: 180,
    direction: 'South',
    roofSlope: 30,
    shadeFactor: 0.96,
    inverterOption: 'standard',
    energyHabit: 'inHalfDay',
    annualConsumptionKwh: 3500,
    postcode: '',
    battery: 'none',
};

export const getSuggestedFormDefaults = (panelOptions = []) => {
    const firstPanelOption = Array.isArray(panelOptions) && panelOptions.length > 0
        ? panelOptions[0]?.value || ''
        : '';

    return {
        ...defaultFormValues,
        size: firstPanelOption,
    };
};

export const getInitialFormValues = (savedValues = {}, panelOptions = []) => {
    const defaults = getSuggestedFormDefaults(panelOptions);

    return {
        ...defaults,
        ...savedValues,
        ...Object.entries(defaults).reduce((acc, [key, value]) => {
            if (savedValues[key] === '' || savedValues[key] == null) {
                acc[key] = value;
            }
            return acc;
        }, {}),
    };
};
